import regionCountryList from './regionsCountryList.json'
import _ from 'lodash'

export const regionOrder = ["East Asia & Pacific", "Europe & Central Asia", "Latin America & Caribbean", "Middle East & North Africa", "South Asia", "Sub-Saharan Africa", "Other"]


const getTreeData = (filterValue) => {

    const filteredRegions = regionCountryList.filter(el => el.type === filterValue)

    const regionList = [ ...new Set(filteredRegions.map(el => el.region).sort()) ]

    const orderedRegions = regionOrder.map(el => regionList.find(d => d === el))

    const treeData = orderedRegions.map(region => {
        return {  title: region, value: region, key: region, children: 
                _.uniqBy(filteredRegions
                                .filter(country => country.region === region)
                                .map(el => {return {title: el.country, value: el.country, key: el.code}})
                                .sort((a,b) => a.title.localeCompare(b.title)), 'key')
                    }
    })

    return {treeData, regionList}
}

export default getTreeData
